// extracted by css-extract-rspack-plugin
export default {"right":"jMDbR","ad":"hT1KA","right_wrapper":"HbH_J","rightWrapper":"HbH_J"};